import { render, staticRenderFns } from "./exercisesType_tree.vue?vue&type=template&id=f2873980&scoped=true"
import script from "./exercisesType_tree.vue?vue&type=script&lang=js"
export * from "./exercisesType_tree.vue?vue&type=script&lang=js"
import style0 from "./exercisesType_tree.vue?vue&type=style&index=0&id=f2873980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2873980",
  null
  
)

export default component.exports